// extracted by mini-css-extract-plugin
module.exports = {"text":"label_text__t42Gt","asterisk":"label_asterisk__1Er5E","errorLabel":"label_errorLabel__2-NEg"};